import superagentPromisePlugin from 'superagent-promise-plugin'

import http_agent from './http_agent'
import config from 'config'

function _genericCatch() {
	return {
		valid: false,
		message: 'Something went wrong. Please try again later.',
	}
}

function getPreview(id, idType, libraryUID, fromStrand) {
	const params = {
		method: 'getPreview',
	}
	if (idType === 'id') {
		params.id = id
	} else {
		params.entityUID = id
	}
	if (libraryUID) {
		params.privateLibraryId = libraryUID
	}
	if (fromStrand) {
		params.strand = fromStrand
	}
	return http_agent.post(config.services + 'service.php')
		.send(params)
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const responseData = JSON.parse(response.text)
			return responseData
		})
		.catch(err => _genericCatch(err))
}

function getBundle(entityUID, origin, libraryUID, fromStrand) {
	const params = {
		method: 'getBundle',
	}
	params.entityUID = entityUID
	if (libraryUID) {
		params.privateLibraryId = libraryUID
	}
	if (fromStrand) {
		params.strand = fromStrand
	}
	return http_agent.post(config.services + 'service.php')
		.send(params)
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const responseData = JSON.parse(response.text)
			return responseData
		})
		.catch(err => _genericCatch(err))
}

export default {
	getPreview,
	getBundle,
}
